import React from 'react'
import moment from 'moment'
import 'moment/locale/th'

interface Props {
  masterMachines: any[]
  id: number
  seq: number
  status: string
  itemInventory: {}[]
  onScan: (id: number) => void
  onPrint: (id: number) => void
  onChangeStatus: (id: string) => void
}

const PileExecutedCardItem: React.FC<Props> = ({
  masterMachines,
  id,
  seq,
  status,
  itemInventory,
  onScan,
  onPrint,
  onChangeStatus,
}) => {
  const isInProgress = status.toLowerCase() === 'in-progress'
  // const isCompleted = status.toLowerCase() === 'completed'
  const options = [
    {
      label: 'เสียหาย - ซ่อมแซม',
      value: 'repairing',
    },
    {
      label: 'เสียหาย - เปลี่ยน',
      value: 'change-pile',
    },
    {
      label: 'กำลังดำเนินการ',
      value: 'in-progress',
    },
    {
      label: 'เสร็จสิ้น',
      value: 'completed',
    },
  ]

  let statusColor = ''
  if (status.toLowerCase() === 'completed') {
    statusColor = 'badge-success'
  } else {
    statusColor = 'badge-primary'
  }
  const pileStatus = options.find(o => o.value === status)

  return (
    <div className='card shadow-sm px-0'>
      <div className='card-header'>
        <div className='card-title'>เสาต้นที่ {seq}</div>
        <div className='card-toolbar'>
          <span className={`badge ${statusColor}`}>{pileStatus?.label ?? 'ไม่พบสถานะ'}</span>
        </div>
      </div>
      <div className='card-body'>
        {itemInventory.map((item: any, idx: number) => (
          <React.Fragment key={`item-inventory-${idx}`}>
            <div className='mb-5'>
              <div className='fw-bold'>
                ({idx + 1}) {item.pileTitle}
              </div>
              <div>Serial : {item.inventoryCode}</div>
              <div>รหัสเสา : {item.pileCode}</div>
              <div>เวลา : {moment(item.usedAt).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm')}</div>
              <div>
                เครื่องจักรที่ใช้ตอก :{' '}
                {masterMachines.find(pm => pm.value === item.projectMachineId)?.label ?? '-'}
              </div>
              <div>Pile No. : {item.pileNo}</div>
              <div>Grid Line : {item.gridLine}</div>
              <div>สถานที่ : {item.location}</div>
            </div>

            <hr />
          </React.Fragment>
        ))}
      </div>

      <div className='card-footer py-4'>
        {isInProgress && (
          <button className='btn btn-sm btn-primary fw-bold me-4' onClick={() => onScan(id)}>
            ดำเนินการต่อ
          </button>
        )}

        <button
          className='btn btn-sm btn-secondary fw-bold me-4'
          onClick={() => onChangeStatus(id.toString())}>
          เปลี่ยนสถานะ
        </button>

        <button className='btn btn-sm btn-primary fw-bold' onClick={() => onPrint(id)}>
          พิมพ์รูปภาพ
        </button>
      </div>
    </div>
  )
}

export default PileExecutedCardItem
